module.exports = __webpack_public_path__ + "img/flat.5352be52.svg";